import React from "react";
import { Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import TableHeader from "../table/TableHeader";
import MainTableBody from "../table/MainTableBody";
import CustomTable from "../table/CustomTable";
import NoDataTable from "../table/NoDataTable";
import VerificationProfileTableRow from "./VerificationProfileTableRow";

const columns = ["Name", "Linked Associations", "Last Updated", "Actions"];

export default function VerificationProfileTable({ reqState, refetch }) {
  const navigate = useNavigate();
  const { isLoading, response } = reqState;
  const isAdmin =
    JSON.parse(Cookies.get("userDets") || "{}").role === "ADMIN";

  return (
    <div
      className="py-1 px-4"
      style={{
        height: `calc(100vh - 100px)`,
      }}
    >
      <div className="flex flex-row mb-4 items-center justify-between">
        <p className="text-xl mb-0 font-extrabold">
          Face Verification Settings
          {Array.isArray(response) ? ` (${response.length})` : ""}
        </p>
        <div className="flex flex-row">
          <button
            onClick={() => refetch()}
            className="border focus:border-blue-600 flex items-center border-[#E0E0E0] mx-2 rounded py-1.5 px-3"
          >
            Refresh Data
          </button>
          {isAdmin && (
            <button
              onClick={() => navigate("create")}
              className=" bg-purple-300 flex items-center py-2 pl-2 pr-3 text-white font-bold rounded"
            >
              <Add fontSize="small" className="ml-0 pl-0 " />
              Create
            </button>
          )}
        </div>
      </div>
      {!response && !isLoading ? (
        <NoDataTable
          columns={columns}
          recordingKeyClassName={true}
          message={"Server Error, Please try again later."}
        />
      ) : response?.length === 0 && !isLoading ? (
        <NoDataTable
          columns={columns}
          recordingKeyClassName={true}
          message={
            "No face verification settings yet. Create one to see it here. Associations without one use the default settings."
          }
        />
      ) : (
        <CustomTable>
          <TableHeader columns={columns} />
          <MainTableBody isLoading={isLoading}>
            {(response || []).map((row) => (
              <VerificationProfileTableRow
                key={row.profileId}
                row={row}
                refetch={refetch}
              />
            ))}
          </MainTableBody>
        </CustomTable>
      )}
    </div>
  );
}
